import { Create } from '@fund/api-modules';
// import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
      passportid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      userid: uid,
      passportid,
      version: '6.5.5',
      ServerVersion: '6.5.5',
      customerno: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  baseURL: 'https://uni-fundts.1234567.com.cn', // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class DataappiApi {
  getShowByProductCode(FCODE) {
    return this.GET('/bigshotshow/getShowByProductCode', {
      fundCode: FCODE,
    });
  }

  getuserDynamicListCode(FCODE) {
    return this.GET('/dynamic/show/userDynamicList', {
      code: FCODE,
      types: '6000',
      pagesize: 2,
    });
  }

  getfundbaseinfos(FCODE) {
    return this.GET('/dataapi/fund/fundbaseinfos', {
      columns: 'FCODE,SHORTNAME,FINSALES,ISSBDATE,ISSEDATE,ISSALES,ISBUY,RGBEGIN,RGEND',
      fundCodes: FCODE,
    });
  }
}
export default new DataappiApi();
